import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.2b10e23.png";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="bg-white w-full z-10 py-0 fixed ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 lg:px-8 ">
        <div className=" flex gap-10 justify-between items-center h-16 ">
          <div className="flex-shrink-0">
            <Link to="/" className="text-3xl font-semibold text-gray-800">
              <img className="w-32 md:w-1/2" src={logo} alt="Logo" />
            </Link>
          </div>

          <div className="hidden md:flex space-x-8">
            <Link
              to="/"
              className="text-gray-800 text-sm font-semibold hover:text-gray-400"
            >
              Product
            </Link>
            <Link
              to="/our-works"
              className="text-gray-800 text-sm hover:text-gray-400
"
            >
              Tools
            </Link>
            <Link
              to="/about-us"
              className="text-gray-800 text-sm hover:text-gray-400
"
            >
              Trades
            </Link>
            <Link
              to="/contact"
              className="text-gray-800 text-sm hover:text-gray-400
"
            >
              Dapp Store
            </Link>
            <Link
              to="/contact"
              className="text-gray-800 text-sm hover:text-gray-400
"
            >
              Build
            </Link>
            <Link
              to="/contact"
              className="text-gray-800 text-sm hover:text-gray-400
"
            >
              Support
            </Link>
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-black hover:bg-inherit"
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="fixed top-19 left-0 w-full h-full z-20 bg-gray-50 flex flex-col py-10 px-4">
          <div className="space-y-10 ">
            <Link
              to="/"
              className="block text-xl text-black font-medium hover:text-gray-400
"
              onClick={toggleMenu}
            >
              Products
            </Link>
            <Link
              to="/"
              className="block text-xl text-black font-medium hover:text-gray-400
"
              onClick={toggleMenu}
            >
              Tools
            </Link>
            <Link
              to="/our-works"
              className="block text-xl text-black font-medium hover:text-gray-400
"
              onClick={toggleMenu}
            >
              Trades
            </Link>
            <Link
              to="/about-us"
              className="block text-xl text-black font-medium hover:text-gray-400
"
              onClick={toggleMenu}
            >
              DApp Store
            </Link>
            <Link
              to="/contact"
              className="block text-xl text-black font-medium hover:text-gray-400
"
              onClick={toggleMenu}
            >
              Build
            </Link>
            <Link
              to="/contact"
              className="block text-xl text-black font-medium hover:text-gray-400
"
              onClick={toggleMenu}
            >
              Support
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
